import localFont from 'next/font/local';

export const euclidCircularBRegular = localFont({
    src: '../fonts/euclidCircular-b-regular.woff',
});
export const proximaNovaABlack = localFont({
    src: '../fonts/proximanova-a-black.woff',
});
